'use client';

import { useTheme } from './theme-provider';
import { ThemeLightIcon } from '../Icons/Icons';
import { useEffect, useState } from 'react';

export function ThemeToggle() {
  const [mounted, setMounted] = useState(false);

  // Only use theme after component mounts to avoid SSR issues
  useEffect(() => {
    setMounted(true);
  }, []);

  // Always call the hook (React rules) - now safe because useTheme provides defaults
  const { theme, setTheme, resolvedTheme } = useTheme();

  const toggleTheme = () => {
    if (!setTheme) return;

    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('light');
    } else {
      setTheme('dark');
    }
  };

  // Don't render until mounted to avoid hydration issues
  if (!mounted) {
    return (
      <button className="cursor-pointer" aria-label="Theme toggle" disabled>
        <div className="text-icon-subtle">
          <ThemeLightIcon width={20} height={20} />
        </div>
      </button>
    );
  }

  const getLabel = () => {
    if (theme === 'system') {
      return 'System theme';
    }
    return resolvedTheme === 'dark' ? 'Light mode' : 'Dark mode';
  };

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        toggleTheme();
      }}
      className="cursor-pointer"
      aria-label="Toggle theme"
      title={getLabel()}
    >
      <div className="text-icon-subtle">
        <ThemeLightIcon width={20} height={20} />
      </div>
    </button>
  );
}
